import { locationReducer } from './location';

export default locationReducer;
